module.exports = __webpack_public_path__ + "static/media/HackX-3.538d37e5.jpg";